import { Stack } from 'expo-router';
import Head from 'expo-router/head';
import * as SplashScreen from 'expo-splash-screen';
import * as SystemUI from 'expo-system-ui';
import { StatusBar } from 'expo-status-bar';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { SITE_DESCRIPTION, SITE_TITLE } from '@/constants/site';
import { GameProvider } from '@/game/game-context';
import { colors } from '@/theme';

SplashScreen.preventAutoHideAsync();
SystemUI.setBackgroundColorAsync(colors.bg);

/**
 * The site-wide `<title>` and description. These can't live in `+html.tsx`: the
 * shell can't set the title (react-helmet's own is emitted first, and the first
 * title in a document wins), and any tag it duplicates here would ship twice
 * since helmet dedupes only its own output. Keeping them in helmet is what lets
 * /privacy, /terms and /support override them from their own `<Head>`.
 *
 * Web only: on iOS the same component registers an NSUserActivity for Handoff
 * and Spotlight, which this app has no use for.
 */
function DocumentTitle() {
  if (Platform.OS !== 'web') return null;
  return (
    <Head>
      <title>{SITE_TITLE}</title>
      <meta name="description" content={SITE_DESCRIPTION} />
      <meta property="og:title" content={SITE_TITLE} />
      <meta property="og:description" content={SITE_DESCRIPTION} />
      <meta name="twitter:title" content={SITE_TITLE} />
      <meta name="twitter:description" content={SITE_DESCRIPTION} />
    </Head>
  );
}

export default function RootLayout() {
  useEffect(() => {
    SplashScreen.hideAsync();
  }, []);

  return (
    <GestureHandlerRootView style={{ flex: 1, backgroundColor: colors.bg }}>
      <DocumentTitle />
      <SafeAreaProvider>
        <GameProvider>
          <StatusBar style="light" />
          <Stack
            screenOptions={{
              headerShown: false,
              animation: 'fade',
              contentStyle: { backgroundColor: colors.bg },
            }}
          />
        </GameProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}
